import Income from './Income';

export default Income;
